import { OnSuccess, basePath, fileToUpload, formApi, jsonApi } from "./utils";
import { UserProfile } from "../types/user"
import { getLocale } from "../i18n"

export interface ProfileIdDocuments {
  idBackSide: FileInfo | null
  idFrontSide: FileInfo | null
}

function fullPath(path: string = ""): string {
  return [basePath, "profile", path].join("/")
}

async function getCurrentProfile(): Promise<UserProfile> {
  if (!App.user) return Promise.reject(null);
  return jsonApi.get<{ profile: UserProfile }>(`${fullPath()}?locale=${getLocale()}`)
    .then(response => response.data.profile)
}

async function getProfileIdDocuments(): Promise<ProfileIdDocuments> {
  return jsonApi.get<{ documents: FileInfo[] }>(fullPath("verification_documents"))
    .then(response => {
      const { documents } = response.data
      return { idFrontSide: documents[0] || null, idBackSide: documents[1] || null }
    })
}

async function updateProfile(
  profile: Partial<UserProfile>,
  onSuccess?: OnSuccess<UserProfile>
): Promise<void | FormErrors> {
  const locale = getLocale()
  const onSuccessFunc = typeof(onSuccess) === "string"
    ? () => { document.location.pathname = onSuccess }
    : onSuccess
  return jsonApi.patch<{ profile: UserProfile }>(fullPath(), { locale, profile })
    .then(response => response.data.profile)
    .then(onSuccessFunc)
    .catch((errors: FormErrors) => errors)
}

function filePresent(file?: FileInfo | null): boolean {
  return Boolean(file?.id || file?.selectedFile)
}

async function updateProfileIdDocuments(frontDoc: FileInfo | null, backDoc: FileInfo | null): Promise<void> {
  const formData = new FormData();
  formData.append("locale", getLocale());
  if (!(filePresent(frontDoc) || filePresent(backDoc))) formData.append("documents[dummy]", "");
  if (frontDoc?.id) formData.append("documents[id_id_front_side]", String(frontDoc.id));
  if (backDoc?.id) formData.append("documents[id_id_back_side]", String(backDoc.id));
  if (frontDoc?.selectedFile) formData.append("documents[id_front_side]", fileToUpload(frontDoc.selectedFile));
  if (backDoc?.selectedFile) formData.append("documents[id_back_side]", fileToUpload(backDoc.selectedFile));
  return formApi.put(fullPath("verification_documents"), formData)
}

async function checkValidateConsent () {
  return jsonApi.post("/internal_api/profile/consent_reference/validation");
}

const disableExpiracyReminder = async () => {
  return jsonApi.patch("/internal_api/investment/disable_expired_portfolio_reminder");
}

export default {
  checkValidateConsent,
  getCurrentProfile,
  getProfileIdDocuments,
  updateProfile,
  updateProfileIdDocuments,
  disableExpiracyReminder
}
